import { useMemo } from "react"

import { AgentMessageType } from "@vertesia/common"
import { LoaderCircle } from "lucide-react"

import { MarkdownDisplay } from "@components/displays/MarkdownDisplay"
import { ShimmerText } from "@components/indicators/TypingIndicator"

import { AgentMessage } from "@models/agents"

interface LatestUpdateMessagePanelProps {
    messages: AgentMessage[]
}
export function LatestUpdateMessagePanel({ messages }: Readonly<LatestUpdateMessagePanelProps>) {
    const latestUpdate = useMemo(() => {
        const updateMessages = messages.filter((msg) => msg.type === AgentMessageType.THOUGHT)

        if (!updateMessages.length) {
            return null
        }

        return updateMessages.reduce((latest, current) => {
            return current.timestamp > latest.timestamp ? current : latest
        })?.message
    }, [messages])

    return (
        <div className="w-full mt-2 border rounded-sm border-gray-900 p-2">
            <ShimmerText>
                <div className="flex w-full items-start gap-2">
                    {<LoaderCircle className="mt-2.5 flex flex-shrink-0 size-6 animate-spin motion-safe:animate-[spin_2s_linear_infinite]" />}
                    <div className="w-full h-full max-h-48 overflow-auto">
                        <MarkdownDisplay content={latestUpdate ? latestUpdate : "Having a quick brainstorm."} />
                    </div>
                </div>
            </ShimmerText>
        </div>
    )
}